document.addEventListener('turbolinks:load', function() {
  const h2Elements = document.querySelectorAll('.markdown h2');
  const lastParagraph = document.querySelector('.markdown p:last-child');
  const smarterBoxBanner = document.getElementById('study-smarter-box-banner');
  const smarterBoxBannerSignup = document.getElementById('study-smarter-box-banner-signup');

  let insertBeforeElement = null;

  if (h2Elements.length >= 3) {
    insertBeforeElement = h2Elements[2];
  } else if (h2Elements.length >= 1) {
    insertBeforeElement = h2Elements[h2Elements.length - 1].nextElementSibling;
  } else if (lastParagraph !== null) {
    insertBeforeElement = lastParagraph.nextElementSibling;
  }

  if (insertBeforeElement && smarterBoxBanner) {
    insertBeforeElement.parentNode.insertBefore(
      smarterBoxBanner,
      insertBeforeElement
    );
  }

  if (smarterBoxBannerSignup) {
    if (insertBeforeElement) {
      insertBeforeElement.parentNode.insertBefore(
        smarterBoxBannerSignup,
        insertBeforeElement
      );
    } else {
      document.body.appendChild(smarterBoxBannerSignup);
    }
  }

  document
    .querySelectorAll('.js-study-smarter-box-button')
    .forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const smarterBoxBanner = document.getElementById('study-smarter-box-banner');
        if (smarterBoxBanner) {
          smarterBoxBanner.style.opacity = '0';
          setTimeout(function() {
            smarterBoxBanner.style.display = 'none';
            const smarterBoxBannerSignup = document.getElementById('study-smarter-box-banner-signup');
            if (smarterBoxBannerSignup) {
              smarterBoxBannerSignup.classList.remove('is-hidden');
              smarterBoxBannerSignup.classList.add('visible');
            }
          }, 200);
        }
      });
    });
});
